const prefix = 'create-addon-modal';

export const i18n = {
    title: {
        id: `${prefix}.title`,
        defaultMessage: 'New Subscription',
    },
    cancel: {
        id: `${prefix}.cancel`,
        defaultMessage: 'Cancel',
    },
    create: {
        id: `${prefix}.create`,
        defaultMessage: 'Create',
    },
    createSuccess: {
        id: `${prefix}.createSuccess`,
        defaultMessage: 'Subscription created',
    },
    createError: {
        id: `${prefix}.createError`,
        defaultMessage: 'Failed to create subscription',
    },
} as const;
